import { HttpClient } from '@/services/http/HttpClient';
import { RefreshTokenMiddleware } from '@/services/middleware/RefreshTokenMiddleware';
import { CsrfTokenMiddleware } from '@/services/middleware/CsrfTokenMiddleware';
import { AccessDeniedMiddleware } from '@/services/middleware/AccessDeniedMiddleware';

const fsumClient = new HttpClient([
    { name: 'refreshTokenMiddleware', middleware: new RefreshTokenMiddleware() },
    { name: 'csrfTokenMiddleware', middleware: new CsrfTokenMiddleware() },
    { name: 'accessDeniedMiddleware', middleware: new AccessDeniedMiddleware() },
]);

export { fsumClient };
